import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router doesn't reset scroll position on navigation — the browser
// keeps whatever scroll Y the user was at on the previous page, which is why
// e.g. clicking "View all 8 stacks" from partway down the homepage could
// land partway down (or at the bottom of) the shorter stacks page instead of
// its top. Skips the reset when the URL has a hash (an in-page anchor link),
// so it doesn't fight any future #section scrolling.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
